import { simpleButtonFields } from 'molecules/Button/config';
import imageField from 'molecules/Image/config';
import sectionFields from 'molecules/Section/config';

import type { Component, Input } from '@builder.io/sdk';

const connectMastheadFields = [
  {
    ...imageField('wordmark'),
    helperText: 'Desktop "CONNECT ‘26" wordmark image (uploaded, includes the Prismatic logo and the gradient).',
  },
  {
    ...imageField('wordmarkMobile'),
    helperText: 'Optional mobile wordmark image (≤640px), e.g. the stacked version. Falls back to the desktop one.',
  },
  {
    name: 'body',
    type: 'longText',
    helperText: 'Intro paragraph shown below the wordmark.',
  },
  {
    name: 'dateText',
    type: 'string',
    helperText: 'Date and time line, e.g. "Wednesday, September 16, 2026 · 11:00 AM–4:00 PM ET".',
  },
  {
    name: 'location',
    type: 'string',
    helperText: 'Location line, e.g. "Virtual".',
  },
  {
    name: 'button',
    type: 'object',
    subFields: simpleButtonFields,
    helperText: 'Primary call-to-action button.',
  },
  {
    ...imageField('image'),
    helperText: 'Hero image shown on the right (the audio-style overlay is part of the uploaded image).',
  },
  {
    ...imageField('watermarkImage'),
    helperText: 'Optional faint brand mark shown behind the content on the right. Leave empty for none.',
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const connectMastheadConfig = {
  name: 'ConnectMasthead',
  inputs: connectMastheadFields,
} satisfies Component;

export type ConnectMastheadConfigProps = GenerateBuilder<typeof connectMastheadFields>;

export default connectMastheadConfig;
